










import { Vue, Component } from 'vue-property-decorator';
import EdicionCertificadosBase from './EdicionCertificadosBase.vue';

@Component({
  components: { EdicionCertificadosBase },
})
export default class EdicionCertificadosPantalla extends Vue {}
